import { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { Trash2, MailOpen, Check } from "lucide-react";
import { toast } from "sonner";

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/admin/contact").then((r) => setMessages(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    try { await api.patch(`/admin/contact/${id}/read`); await load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Bu mesajı silmek istediğinize emin misiniz?")) return;
    try {
      await api.delete(`/admin/contact/${id}`);
      toast.success("Silindi");
      if (selected?.id === id) setSelected(null);
      await load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="p-8" data-testid="admin-messages-page">
      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#059669] mb-2">İletişim</p>
      <h1 className="font-display text-3xl md:text-4xl tracking-tighter font-black mb-8">Mesajlar</h1>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        <div className="lg:col-span-5 border border-gray-200 bg-white">
          <div className="px-4 py-3 border-b border-gray-200 text-xs uppercase tracking-[0.18em] text-gray-500">
            {messages.length} mesaj
          </div>
          <div className="divide-y divide-gray-100 max-h-[70vh] overflow-auto">
            {messages.map((m) => (
              <button
                key={m.id}
                onClick={() => { setSelected(m); if (!m.is_read) markRead(m.id); }}
                data-testid={`message-${m.id}`}
                className={`w-full text-left px-4 py-3 hover:bg-gray-50 ${selected?.id === m.id ? "bg-emerald-50" : ""}`}
              >
                <div className="flex items-center justify-between">
                  <p className="font-display text-sm tracking-tight">{m.name}</p>
                  {!m.is_read && <span className="w-2 h-2 bg-[#059669] rounded-full" />}
                </div>
                <p className="text-xs text-gray-500 truncate">{m.subject || m.message}</p>
                <p className="text-[10px] font-mono-fd text-gray-400 mt-1">{new Date(m.created_at).toLocaleString("tr-TR")}</p>
              </button>
            ))}
            {messages.length === 0 && <div className="px-4 py-10 text-center text-gray-400 text-sm">Henüz mesaj yok</div>}
          </div>
        </div>

        <div className="lg:col-span-7 border border-gray-200 bg-white p-6 min-h-[60vh]">
          {selected ? (
            <div>
              <div className="flex items-start justify-between flex-wrap gap-3 mb-6">
                <div>
                  <p className="text-[10px] uppercase tracking-[0.18em] text-gray-500">Gönderen</p>
                  <p className="font-display text-2xl tracking-tighter">{selected.name}</p>
                  <p className="text-sm text-gray-600">{selected.email}{selected.phone ? ` · ${selected.phone}` : ""}</p>
                </div>
                <div className="flex gap-2">
                  {selected.is_read && <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] text-emerald-600"><Check size={12} /> Okundu</span>}
                  <button onClick={() => remove(selected.id)} data-testid="delete-message" className="inline-flex items-center gap-1 text-xs text-red-600 hover:text-red-800">
                    <Trash2 size={14} /> Sil
                  </button>
                </div>
              </div>
              {selected.subject && (
                <div className="mb-4">
                  <p className="text-[10px] uppercase tracking-[0.18em] text-gray-500">Konu</p>
                  <p className="font-display tracking-tight">{selected.subject}</p>
                </div>
              )}
              <div>
                <p className="text-[10px] uppercase tracking-[0.18em] text-gray-500 mb-1">Mesaj</p>
                <p className="text-gray-800 leading-relaxed whitespace-pre-wrap">{selected.message}</p>
              </div>
            </div>
          ) : (
            <div className="h-full flex items-center justify-center text-gray-400 text-sm">
              <MailOpen size={24} className="mr-2" /> Bir mesaj seçin
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
